export default "/assets/images/mila-sock.c4a827c40244fcdf.jpg";